import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useCompany = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [companyList, setCompanyList] = useState<CompanyListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.company.list, location.search],
    () =>
      fetcher.company.postCompanyList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',        
        biz: searchParams.biz ? String(searchParams.biz) : '',       
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',
      }),
    {
      onSuccess: (res: CompanyListResDto) => {
        switch (res.code) {
          case 200:
            setCompanyList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: companyFileUpdate } = useMutation(
    [endpoints.company.filesave],
    fetcher.company.postCompanyFileUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: crmInsert } = useMutation(
    [endpoints.crm.add],
    fetcher.crm.postCrmAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, companyList, searchResult, refetch, companyFileUpdate, crmInsert };
};

export default useCompany;
